module.exports = __webpack_public_path__ + "img/renkeimae_ato.39e4484f.png";